import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'components/icons/CheckIcon';
import { cn } from 'lib/utils';
import { ComponentPropsWithoutRef, ComponentRef, forwardRef } from 'react';

const Checkbox = forwardRef<
  ComponentRef<typeof CheckboxPrimitive.Root>,
  ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-[4px] border border-gray-800 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-800 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
      className,
      'data-[state=checked]:bg-primary-pink-1 data-[state=checked]:border-transparent',
    )}
    ref={ref}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
      <CheckIcon width={16} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
